import _SoleneService from "../services/solene-service";
import { ISoleneService } from "../types/services/solene-sevice";

const instance = new _SoleneService();

export const SoleneService: ISoleneService = instance;
